const PHONE_INPUT_CHARACTERS = /^[\d+\s().-]*$/;

function groupFromRight(value: string): string[] {
  const groups: string[] = [];

  for (let end = value.length; end > 0; end -= 3) {
    groups.unshift(value.slice(Math.max(0, end - 3), end));
  }

  return groups;
}

function formatBrazilianPhone(countryAndLocalDigits: string): string {
  const localDigits = countryAndLocalDigits.slice(2);
  const areaCode = localDigits.slice(0, 2);
  const number = localDigits.slice(2);

  if (!localDigits) return '+55';
  if (localDigits.length <= 2) return `+55 (${localDigits}`;
  if (number.length <= 4) return `+55 (${areaCode}) ${number}`;

  const firstGroupLength = number.startsWith('9') ? 5 : 4;
  const firstGroup = number.slice(0, firstGroupLength);
  const secondGroup = number.slice(firstGroupLength);

  return `+55 (${areaCode}) ${firstGroup}${secondGroup ? `-${secondGroup}` : ''}`;
}

function formatInternationalPhone(digits: string): string {
  if (digits.startsWith('55') && digits.length <= 13) {
    return formatBrazilianPhone(digits);
  }

  if (digits.length <= 4) return `+${digits}`;

  const lastGroup = digits.slice(-4);
  const leadingGroups = groupFromRight(digits.slice(0, -4));

  return `+${[...leadingGroups, lastGroup].join(' ')}`;
}

/**
 * Formats an explicitly international phone login without assuming a country.
 * Entering only digits remains untouched, so no country code is injected.
 */
export function formatLoginPhoneInput(value: string): string {
  if (!value || !PHONE_INPUT_CHARACTERS.test(value)) return value;

  const compact = value.trim();
  const digits = compact.replace(/\D/g, '');
  if (!digits) return compact === '+' ? '+' : '';

  if (compact.startsWith('+')) return formatInternationalPhone(digits);
  if (compact.startsWith('00')) return formatInternationalPhone(digits.slice(2));

  return value;
}

export function isPhoneLoginInput(value: string): boolean {
  return Boolean(value) && PHONE_INPUT_CHARACTERS.test(value);
}
